// Central list of vehicle types used across the app.
// Keep values in sync with the backend enum in models/car.model.js and bookingPackage.model.js.
export const VEHICLE_TYPES = [
  { value: 'car', label: 'Car', icon: '🚗', category: 'four-wheeler', seats: 5 },
  { value: 'suv', label: 'SUV / MUV', icon: '🚙', category: 'four-wheeler', seats: 7 },
  { value: 'bike', label: 'Bike', icon: '🏍️', category: 'two-wheeler', seats: 2 },
  { value: 'scooter', label: 'Scooter', icon: '🛵', category: 'two-wheeler', seats: 2 },
  { value: 'auto', label: 'Auto Rickshaw', icon: '🛺', category: 'three-wheeler', seats: 3 },
  { value: 'bus', label: 'Bus', icon: '🚌', category: 'commercial', seats: 40 },
  { value: 'tempo-traveller', label: 'Tempo Traveller', icon: '🚐', category: 'commercial', seats: 12 },
  { value: 'truck', label: 'Truck / Lorry', icon: '🚛', category: 'commercial', seats: 2 },
  { value: 'van', label: 'Van', icon: '🚐', category: 'four-wheeler', seats: 8 },
  { value: 'pickup', label: 'Pickup Truck', icon: '🛻', category: 'commercial', seats: 2 },
  { value: 'tractor', label: 'Tractor', icon: '🚜', category: 'special', seats: 1 },
  { value: 'jcb', label: 'JCB / Crane', icon: '🏗️', category: 'special', seats: 1 },
  { value: 'ambulance', label: 'Ambulance', icon: '🚑', category: 'special', seats: 4 },
  { value: 'other', label: 'Other', icon: '🚘', category: 'four-wheeler', seats: 4 }
];

// Default seats to pre-fill when a type has none configured.
export const DEFAULT_SEATS = 4;

// "Any" pseudo-type — used where a selection can apply to all vehicles (e.g. packages).
export const ANY_VEHICLE_TYPE = { value: 'any', label: 'Any Vehicle', icon: '🚐' };

// Options list that includes the "Any Vehicle" choice up front.
export const VEHICLE_TYPE_OPTIONS_WITH_ANY = [ANY_VEHICLE_TYPE, ...VEHICLE_TYPES];

// Resolve a value to its display label (falls back to "Any Vehicle").
export const getVehicleTypeLabel = (value) =>
  VEHICLE_TYPE_OPTIONS_WITH_ANY.find(t => t.value === value)?.label || ANY_VEHICLE_TYPE.label;

export default VEHICLE_TYPES;
